import { HStack, IconButton, Text, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { multipleTermsDescription } from '../../../../constants';

export namespace AccordionItemTypes {
  export interface Props {
    title: string;
    children?: multipleTermsDescription;
    isLast: boolean;
    showContent: boolean;
    onPress: () => void;
  }
}

export const AccordionItem: React.FC<AccordionItemTypes.Props> = ({
  title,
  children,
  isLast,
  showContent,
  onPress,
}) => {
  return (
    <VStack
      borderBottomWidth={isLast ? 0 : 1}
      borderColor="neutral.lightest"
      py={Spacing['stack.xxxs']}>
      <HStack justifyContent="space-between" space={Spacing['inline.nano']} alignItems="center">
        <Text variant="semibold" fontSize="md">
          {title}
        </Text>
        <IconButton
          testId="accordion-item-download"
          icon={showContent ? 'ChevronUp' : 'ChevronDown'}
          iconColor="neutral.dark"
          padding="0px"
          onPress={onPress}
          iconSize="xs"
        />
      </HStack>
      {showContent && children && (
        <VStack py={Spacing['stack.xxxs']} space={Spacing['stack.xxxs']}>
          {children.map((item) => (
            <Text variant="regular" fontSize="md" color="neutral.dark" key={item.title}>
              {item.title}
            </Text>
          ))}
        </VStack>
      )}
    </VStack>
  );
};
